export default __webpack_public_path__ + "static/media/p2p-img.5c3b4819.webp";